module.exports = __webpack_public_path__ + "static/media/supermini-mp35.cce4df73.png";